/* eslint-disable react/no-danger */
import React from 'react';

const RawHtml = ({ html }) => {
  return <div dangerouslySetInnerHTML={{ __html: html }} />;
};

export default RawHtml;
